module.exports = __webpack_public_path__ + "img/shipblu-secure.d969dd13.svg";